<template>
  <div>
    <Header :notHome="true" ref="headerLine"></Header>
    <pageNav :breadcrumbsList="breadcrumbsList" :title="pageName"></pageNav>
    <div class="main-content-area">
      <div class="new-area" ref="newArea">
        <div class="area-bg" ref="bgArea" :style="`{top:${offsetTop}px}`">
          <div class="bg-img">
            <img src='../../assets/image/bg33.png' class="d-sm-none d-xl-block" />
            <img src='../../assets/image/bg34.png' class="d-sm-block d-xl-none" />
          </div>
        </div>
        <div class="new-box">
          <b-container fluid>
            <b-row class="show-item-list">
              <b-col xl="4" sm="6" v-for="(item, index) in list" :key="index" @click="goPage(item)">
                <div class="news-item flex flex-column align-center">
                  <div class="news-img flex align-center justify-center">
                    <img :src="$BaseUrl+item.image" />
                  </div>
                  <div class="news-info flex flex-column justify-between">
                    <div class="news-title overHidden2">{{ item.title }}</div>
                    <div class="news-content">
                      <!-- <span>{{ (item.publishDate||'').substring(0,10).replace(/-/g,'/') }}</span> -->
                      <span>{{ (item.publishDate||'').replace(/-/g,'/') }}</span>
                      <div class="overHidden2">{{ item.desc }}</div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col sm="12">
                <!-- 获得底部位置判断是否加载下一页数据 -->
                <div ref="lastDiv"></div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { getContentList } from "@/api/news"
export default {
  data() {
    return {
      breadcrumbsList: [],
      endDivTop: 0,
      currentPage: 1,
      categoryTwo: null,
      categoryOne: null,
      list: [],
      pages: 1,
      type: null,
      scroll: 0,
      pageName: '新闻动态',
      loading: false,
      offsetTop: 0
    }
  },
  mounted() {
    this.countViewCount()
    this.categoryOne = this.$route.query.categoryOne
    this.categoryTwo = this.$route.query.categoryTwo
    this.type = this.$route.query.type
    this.scroll = this.$route.query.scroll
    let result = this.getNavListByType(this.type, this.scroll)
    this.breadcrumbsList = result.list
    this.pageName = result.name
    this.$nextTick(() => {
      this.offsetTop = this.$refs.newArea.offsetTop
      this.$refs.bgArea.style.top=(this.offsetTop-10)+'px'
      if (this.type != 'news') {
        this.$refs.headerLine.changeCurrent(this.type)
      }
      this.endDivTop = this.$refs.lastDiv.offsetTop
      window.addEventListener("scroll", this.handleScroll)
    })
    this.getList()
  },
  methods: {
    getList() {
      getContentList({ categoryOne: this.categoryOne, categoryTwo: this.categoryTwo, pageSize: 9, pageNum: this.currentPage }).then(res => {
        if (res.code == 200) {
          if (this.currentPage == 1) {
            this.list = res.rows.map(v => {
              v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
              return v
            })
          } else {
            this.list = this.list.concat(res.rows.map(v => {
              v.desc = (v.content || '').replace(/<img.*?>/g, "").replace(/<\/?.+?\/?>/g, ' ')
              return v
            }))
          }
          this.pages = Math.ceil(res.total / 9)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleScroll(e) {
      this.offsetTop=this.$refs.newArea.getBoundingClientRect().top<160?160:this.$refs.newArea.getBoundingClientRect().top
      this.$refs.bgArea.style.top=(this.offsetTop-10)+'px'
      // this.offsetTop=this.$refs.newArea.offsetTop
      let nowTop = e.target.scrollTop || document.documentElement.scrollTop
      if (nowTop - this.endDivTop > 200 && (this.currentPage + 1) <= this.pages && !this.loading) {
        this.loading = true
        // 滑动到底了且有下一页
        this.currentPage = this.currentPage + 1
        this.getList()
      }
    },
    goPage(item) {
      this.$router.push({ path: '/newsDetail?contentId=' + item.contentId + '&type=' + this.type + '&pageName=' + this.pageName + '&scroll=' + this.scroll })
    },
  }
}
</script>
<style lang="scss" scoped>
.new-area {
  // background: linear-gradient(to bottom, #d3e1f5 0, #fff 700px);
  .area-bg {
    width: 100%;
    z-index: -1;
    position: fixed;
    min-height: 2774px;
  }
  .new-box {
    max-width: 1180px;
    margin: 0 auto;
    padding-top: 60px;
    min-height: 100vh;
    .show-item-list {
      > div {
        padding: 0;
      }
    }

    .news-item {
      width: calc(100% - 15px);
      margin: 0 auto;
      box-shadow: 0px 0 23px 0px rgba(10, 49, 128, 0.1);
      border: 1px solid #e0e0e0;
      margin-bottom: 15px;
      background: transparent;
      cursor: pointer;

      .news-img {
        // width: 295px;
        width: 100%;
        height: 214px;
        overflow: hidden;
        background: #fff;
        img {
          object-fit: cover;
          // width: 295px;
          width: 100%;
          height: 214px;
        }
      }

      .news-info {
        // width: 295px;
        width: 100%;
        min-height: 163px;
        background: #fff;

        .news-title {
          padding: 15px 15px 0 15px;
          font-family: "SourceHanSansCN-Regular";
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 36px;
          min-height: 87px;
        }

        .news-content {
          padding: 0 15px 15px 15px;

          > span:first-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 20px;
            color: #999999;
          }

          > div:last-of-type {
            font-family: "SourceHanSansCN-Regular";
            font-weight: 400;
            font-size: 20px;
            color: #666666;
            line-height: 30px;
            min-height: 48px;
          }
        }
      }
    }

    .news-item:hover {
      .news-img {
        background: #1566d4;
      }
      .news-info {
        background: #1566d4;

        .news-title {
          color: #fff;
        }

        .news-content {
          > span:first-of-type {
            color: rgba(255, 255, 255, 0.7);
          }

          div:last-of-type {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
}
// 移动端
@media (min-width: 576px) and (max-width: 1200px) {
  .show-item-list {
    padding: 0 24px;
  }
  .area-bg {
    height: calc(100vh - 524px) !important;
  }
  .news-item {
    .news-img {
      max-width: 341px;
      height: 192px !important;
      img {
        max-width: 341px;
        height: 192px !important;
      }
    }
    .news-info {
      .news-title {
        font-size: 26px !important;
      }
      .news-content {
        span {
          font-size: 20px !important;
        }
        div {
          font-size: 24px !important;
        }
      }
    }
  }
  // .{
  //   height: 192px;
  // }
}
</style>